import React from "react";
import withIntl from "../../utils/withIntl";
import { Box, Grid, IconButton, MenuItem, Select, Typography } from "@material-ui/core";
import { Add, Close } from "@material-ui/icons";
import cloudStore from "../../store/CloudStore";

function PillarUsers(props) {
  const printer = props.printer;
  const [pillarUsers, setPillarUsers] = React.useState(printer.pillar_users);
  const [addUser, setAddUser] = React.useState("");
  const availableUsers = cloudStore.merchant.pillar_merchants.reduce((pillarUsers, pillarMerchant) => {
    return pillarUsers.concat(pillarMerchant.pillar_users);
  }, []);

  return (
    <>
      <Grid item xs={12} container spacing={1} style={{ maxWidth: 480 }} alignContent={"center"} alignItems={"center"}>
        <Grid item xs={12}>
          <Typography>
            <Box fontWeight={800}>{props.intl.formatMessage({ id: "kiosk_users" })}</Box>
          </Typography>
        </Grid>

        {pillarUsers.map((pillarUser, index) => {
          return (
            <>
              <Grid item xs={1}>
                <IconButton
                  size={"small"}
                  onClick={() => {
                    pillarUsers.splice(index, 1);
                    setPillarUsers([...pillarUsers]);
                    props.setPillarUsers([...pillarUsers]);
                  }}
                >
                  <Close />
                </IconButton>
              </Grid>
              <Grid item xs={11}>
                {pillarUser.email}
              </Grid>
            </>
          );
        })}
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <Box fontWeight={800}>{props.intl.formatMessage({ id: "add_kiosk_user" })}</Box>
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Select
            style={{ width: "100%" }}
            value={addUser}
            onChange={(e) => {
              if (e.target.value !== "") {
                setAddUser(e.target.value);
              }
            }}
          >
            {availableUsers
              .filter((user) => {
                return !pillarUsers.find((pillarUser) => {
                  return user.id === pillarUser.id;
                });
              })
              .map((user) => {
                return <MenuItem value={user}>{user.email}</MenuItem>;
              })}
          </Select>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            size={"small"}
            onClick={() => {
              if (addUser === "") {
                return;
              }
              pillarUsers.push(addUser);
              setPillarUsers([...pillarUsers]);
              props.setPillarUsers([...pillarUsers]);
            }}
          >
            <Add />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}

export default withIntl(PillarUsers);
